import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

const FlashFlood48hEULegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.flashflood")} (ITA) - 48h</b>
      </div>
      <div>
        <span style={legendItemStyle("#f9f9f9")}></span>Low: 0 &lt; pp level (mm/h) &lt; 1.5
      </div>
      <div>
        <span style={legendItemStyle("#d0efff")}></span>
        Moderate: 1.5 &le; pp level (mm/h) &lt; 3
      </div>
      <div>
        <span style={legendItemStyle("#187bcd")}></span>
        Significant: 3 &le; pp level (mm/h) &lt; 5
      </div>
      <div>
        <span style={legendItemStyle("#03254c")}></span>
        High: pp level (mm/h) &ge; 5
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          pp level = precipitation level, measured in mm/h
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, Data from RAIN Project, funded by the European Commission, processed by CyStellar
        </span>
      </div>
    </div>
  );
};

export default FlashFlood48hEULegend;
